export default {
  pageTitle: 'Aftersale',
  returnAddress: 'Return Address(Aftersale)',
  shippingAddressAfter: 'Shipping Address(Aftersale)',
  radio1: 'Pending review',
  radio2: 'rejected',
  radio3: 'Processing',
  radio4: 'Completed',
  radio5: 'Closed',
  order: 'Order',
  SKU: 'SKU',
  userId: 'User ID',
  userPhone: 'User phone',
  postageBurden1: 'Platform',
  postageBurden2: 'Seller',
  postageBurden3: 'User',
  createDate: 'Create Date',
  origin1: 'App',
  origin2: 'Wap',
  origin3: 'Email',
  origin4: 'Facebook',
  refundStatus1: '无',
  refundStatus2: '待生成',
  refundStatus3: '待审核',
  refundStatus4: '待退款',
  refundStatus5: '退款中',
  refundStatus6: '已退款',
  SoList1: 'SO number',
  SoList2: 'Shipping package number',
  afterSaleStatusMapping1: '待商家审核',
  afterSaleStatusMapping2: '待平台审核',
  afterSaleStatusMapping3: '处理中',
  afterSaleStatusMapping4: '售后完成',
  afterSaleStatusMapping5: '商家拒绝',
  afterSaleStatusMapping6: '平台拒绝',
  afterSaleStatusMapping7: '用户取消',
  columns1: 'ID',
  columns2: 'User ID',
  columns3: 'SO#',
  columns4: 'Create date',
  columns5: 'Order close time',
  columns6: 'Close type',
  columns7: 'Application dimension',
  columns8: 'SKU ID',
  columns9: 'Order amount',
  columns10: 'Payment Amount',
  columns11: 'Who pay delivery charge',
  columns12: 'Operation',
  columns13: 'Source',
  columns14: 'Who apply',
  columns15: 'Status',
  columns16: 'Refund',
  columns17: 'System ID',
  viewDetail: 'View Detail',
  inner1: 'Admin',
  inner2: 'User',
  error1: 'id错误',
  isAppeal: '是否申诉',
  appealed: 'Appealed',
  buyerName: 'Buyer Name',
  orderNum: 'Order No.',
  orderAmount: 'Order Amount',
  orderCompleteTime: 'Order Complete Time',
  paymentTime: 'Payment Time',
  logisticsType: 'Logistics Type',
  storeId: 'Store Id',
  storeName: 'Store Name',
  pendingReview: 'Pending Review',
  processing: 'Processing',
  completed: 'Completed',
  afterSaleDetail: 'After Sale Detail - {0}',
  afterSaleDetailTitle: 'Application Desciption',
  orderStatus: 'Order Status',
  afterSaleType: 'Service Type',
  applyTime: 'Application Time',
  refundAmount: 'Refund Amount',
  reason: 'Reason',
  remark: 'Remark',
  refundTime: 'Refund Time',
  refundInformation: 'Refund Information',
  processingTime: 'Processing Time',
  newServiceType: 'Service Type',
  changServiceType: 'Service Type',
  changReason: 'Reason',
  adjustReason: 'Reason',
  rejectReason: 'Reason',
  sellerProvidedANewSolution: 'Seller new solution information',
  sellerHasRejectedTheApplication: 'Seller has rejected the application',
  agreesWithSellerSolution: 'Kilimall agrees with seller solution',
  agreedWithCustomerApplication: 'Kilimall agreed with customer application',
  KilimallRejectedTheApplication: ' Kilimall rejected the application',
  KilimallProvidedANewSolution: ' Kilimall provided a new solution',
  exchangeInformation: ' Exchange Information',
  logisticsTrackingNumber: ' Logistics tracking number',
  agreeConfirm: 'Agree & Confirm',
  changeSolution: 'Change Solution',
  contactBuyer: 'Contact Buyer',
  returnInfoDetails: 'Return Information Details',
  Reject: 'Reject',
  remarkPlaceholder: 'Please add specific reasons and descriptions',
  rejectRemarkPlaceholder: 'Please add specific reasons and descriptions',
  maxiMum: 'Maximum',
  cancel: 'Cancel',
  confirm: 'Confirm',
  rejectAfterSale: 'Reject after-sales application',
  pleaseChoose: 'Please choose',
  pleaseEnterTheRefundAmount: 'Please enter the refund amount',
  pleaseEnterTheCorrectAmount: 'Please enter the correct amount',
  productsAmount: 'Products Amount',
  allReceived: 'All received',
  pendingPayment: 'Pending Payment',
  pendingConfirmation: 'Pending Confirmation',
  pendingDispatch: 'Pending Dispatch',
  inTransit: 'In Transit',
  CustomerArbitration: 'Consumer Intervention Information',
  afterSaleTime: 'End in',
  qualityInspectionResult: 'Quality inspection result',
  Responsible: 'Responsible',
  kiliMallEditProject: 'Kilimall platform has modified the application',
  logisticsProvider: 'Logistics provider',
  logisticsNumber: 'Logistics number',
  refundMethod: 'Refund method',
  pickupAddress: 'Pickup address',
  shippingAddress: 'Shipping address',
  returnInfo: 'Return Information',
  returnInfoRouter: 'Return Info - {0}',
  returnLogisticsTrack: 'Return logistics track'
}
